import { useFlags } from 'launchdarkly-react-client-sdk';
import { Link, useLocation } from 'react-router-dom';

interface SubMenuProps {
  readonly title: string;
  readonly items: readonly { name: string; link: string; icon?: JSX.Element; hidden?: boolean }[];
}

export function SubMenu({ title, items }: SubMenuProps) {
  const { pathname } = useLocation();
  const { launchAccountMenu } = useFlags();

  if (items.length === 0) {
    return null;
  }

  return (
    <div>
      <span className="text-content-on-dark-subdued text-[12px]">{title}</span>
      <div className="flex flex-col gap-2 mt-2 text-content-on-dark-default text-[14px]">
        {items.map((item) => {
          if (item.hidden && launchAccountMenu) {
            return null;
          }

          const pathParts = item.link.split('/');
          let link = item.link;
          if (pathParts.length > 3) {
            link = pathParts.slice(0, -1).join('/');
          }

          return (
            <Link
              to={item.link}
              key={item.name}
              className={`flex items-center gap-2 p-2 hover:bg-cool-gray-800 rounded-md cursor-pointer ${
                pathname.includes(link) ? 'bg-cool-gray-800' : ''
              }`}
            >
              {item?.icon}
              <span className="">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
